export const enableEncryption = true;